import React, { useState, useEffect } from "react";

import {
  Box,
  Flex,
  Link,
  Text,
  useDisclosure,
  useBreakpointValue,
  Icon,
  Tooltip,
  MenuButton,
  MenuList,
  MenuItem,
  Menu,
  TabPanels,
  TabPanel,
  SimpleGrid,
  List,
  ListItem,
} from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";
import { FaDownload } from "react-icons/fa";
import { Link as ReactLink, useHistory } from "react-router-dom";
import { TableRelatorioPendencia } from "../../../components/TableRelatorioPendencia";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { RiFileExcel2Line } from "react-icons/ri";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { FiltersRelatorioServicoAcolhimento } from "../../../components/FiltersRelatorioServicoAcolhimento";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import {
  servicoAcolhimentoFunc,
  criancaFunc,
  dashboardFunc,
} from "../../../../helpers/Funcionalidades";
import Swal from "sweetalert2";
import RelatorioService from "../../../../main/services/RelatorioService";
import SemRegistros from "../../../components/SemRegistros";
import { PopoverGenero } from "../../../components/PopoverGenero";
import { format } from "date-fns";
import { RiPushpinLine } from "react-icons/ri";
import { PrintButtonRelatorioServico } from "../../../components/PrintButtonRelatorioServico";

export const RelatoriosServicoAcolhimento = () => {
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ, usuarioLogado } = useAppContext();

  const history = useHistory();

  const [mostrarTabela, setMostrarTabela] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [hintPreliminar, setHintPreliminar] = useState(false);
  const placement = useBreakpointValue({ md: "left" });

  const {
    isOpen: isOpenNovoAcolhimento,
    onOpen: onOpenNovoAcolhimento,
    onClose: onCloseNovoAcolhimento,
  } = useDisclosure();
  const [atualizarDadosTabela, setAtualizarDadosTabela] = useState(false);
  const storage = JSON.parse(
    sessionStorage.getItem("relatorio-servico-acolhimento-filter"),
  );

  const columns = [
    {
      Header: "Serviço de Acolhimento Atual",
      accessor: "servicoAcolhimentoNomeFantasia",
      Cell: (props) => {
        const permissaoServico =
          roleKeycloack.includes(criancaFunc.visualizarTudo) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM,
          ) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
          ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
            roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              props?.row?.original?.idPessoaJuridica,
            ));
        const temRiscoVida =
          props?.row?.original?.riscoVida === "S" ? true : false;

        if (temRiscoVida && !permissaoServico) {
          return <span></span>;
        } else {
          const idServico = props?.row?.original?.id;
          if (!idServico) {
            return <span></span>;
          } else {
            return (
              <>
                {roleKeycloack &&
                roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
                  <Link
                    wordBreak={"break-word"}
                    title={props?.value}
                    as={ReactLink}
                    to={"/servico-acolhimento/" + idServico}
                  >
                    <Text> {props?.value}</Text>
                  </Link>
                ) : (
                  <Text>{props?.value}</Text>
                )}
              </>
            );
          }
        }
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Telefone",
      accessor: "telefone",
      Cell: ({ value }) => {
        if (!value) return null;

        return (
          <div>
            {value.split("\n").map((tel, index) => (
              <div key={index} style={{ whiteSpace: "nowrap" }}>
                {tel}
              </div>
            ))}
          </div>
        );
      },
    },

    {
      Header: "Endereço",
      accessor: "endereco",
      Cell: (props) => {
        return <Text minWidth="300px">{props.value}</Text>;
      },
    },
    {
      Header: "Vagas Disponíveis",
      accessor: "vagasDisponiveis",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
  ];

  useEffect(() => {
    const storage = sessionStorage.getItem(
      "relatorio-servico-acolhimento-filter",
    );

    if (!storage && mostrarTabela) {
      setMostrarTabela(false);
    }
  }, [storage, mostrarTabela]);

  const renderizarTooltip = () => {
    if (isMobile)
      return (
        <PopoverGenero
          isOpen={hintPreliminar}
          setIsOpen={setHintPreliminar}
          flex={true}
          handleClick={() => setHintPreliminar(!hintPreliminar)}
          labelTextoGenero={
            "Durante o período pesquisado é possível que uma criança ou adolescente tenha mais de um movimento. Na versão Excel completo, o resultado da pesquisa exibirá todos esses movimentos."
          }
        />
      );

    return (
      <Tooltip
        label={
          "Durante o período pesquisado é possível que uma criança ou adolescente tenha mais de um movimento. Na versão Excel completo, o resultado da pesquisa exibirá todos esses movimentos."
        }
        fontSize="md"
        maxW="400px"
        textAlign={"justify"}
        placement={placement}
      >
        <span className="hint-tooltip">
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize={{ base: "20px" }}
          />
        </span>
      </Tooltip>
    );
  };

  const renderSN = (value) => {
    if (!value || value.length === 0) return "";

    const hasS = value.includes("S");
    const hasN = value.includes("N");

    if (hasS && hasN) return " Sim e Não";
    if (hasS) return " Sim";
    if (hasN) return " Não";

    return "";
  };

  const getExportarExecel = async (tipo) => {
    const statusMap = {
      A: "ATIVO",
      D: "DESATIVADO",
      S: "SUSPENSO",
    };
    const status = storage?.statusRelatorio.map((item) => statusMap[item]);
    const generos = (storage?.idGenero || [])
      ?.flat()
      ?.map((item) => item.genero)
      ?.filter(Boolean);
    const nomeServicosAcolhimentos = (storage?.idsServicosAcolhimento || [])
      ?.flat()
      ?.map((item) => item.nomeFantasia)
      ?.filter(Boolean);
    const municipiosOrgaos = (storage?.idMunicipioOrgao || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter((id) => id !== "" && id != null);
    const promotoriasOrgaos = (storage?.idPromotoriaOrgaos || [])
      ?.flat()
      ?.map((item) => ({
        id: item.id,
        idMunicipio: item.idMunicipio,
      }))
      ?.filter((id) => id !== "" && id != null);
    const varasOrgaos = (storage?.idVaraOrgaos || [])
      ?.flat()
      ?.map((item) => ({
        id: item.id,
        idMunicipio: item.idMunicipio,
      }))
      ?.filter((id) => id !== "" && id != null);
    const naturezas = (storage?.naturezaServico || [])
      ?.flat()
      ?.map((item) => item?.id?.toUpperCase())
      ?.filter((id) => id !== "" && id != null);
    const regimes = (storage?.regime || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter((id) => id !== "" && id != null);
    const modalidades = (storage?.modalidade || [])
      ?.flat()
      ?.map((item) => item.descricao)
      ?.filter(Boolean);
    const SAF =
      Array.isArray(storage?.regime) &&
      storage?.regime?.flat()?.some((item) => item.id === "SAF");
    const idadeMin = [storage?.idadeInicial, storage?.idadeMinima].find(
      (v) => v != null && v !== "" && v !== "null",
    );

    const idadeMax = [storage?.idadeFinal, storage?.idadeMaxima].find(
      (v) => v != null && v !== "" && v !== "null",
    );

    const valuesToSend = {
      tipoRelatorio:
        tipo === "basico"
          ? "RELATORIO_SERVICOS_ACOLHIMENTOS_BASICO"
          : "RELATORIO_SERVICOS_ACOLHIMENTOS_COMPLETO",
      status: status,
      localizacaoServicoAcolhimento: {
        estados: storage?.idEstado
          ? storage?.idEstado
              .flat()
              .map((item) => item.id)
              .filter((item) => item.id !== "")
          : [],
        municipios: storage?.idMunicipio
          ? storage?.idMunicipio
              .flat()
              .map((item) => ({
                id: item.id,
                idEstado: item.idEstado,
              }))
              .filter((item) => item.id !== "")
          : [],
        bairros: storage?.idBairro
          ? storage?.idBairro
              .flat()
              .map((item) => ({
                id: item.id,
                idMunicipio: item.idMunicipio,
              }))
              .filter((item) => item.id !== "")
          : [],
        nomeServicosAcolhimentos: nomeServicosAcolhimentos,
      },
      orgaos: {
        municipios: municipiosOrgaos,
        promotorias: promotoriasOrgaos,
        varasInfancias: varasOrgaos,
      },
      caracterizacaoServicoAcolhimento: {
        regimes: regimes,
        modalidades:
          SAF &&
          !modalidades.includes("Não se aplica") &&
          modalidades?.length > 0
            ? [...modalidades, "Não se aplica"]
            : modalidades,
        naturezas: naturezas,
      },
      perfilAtendimento: {
        ...(storage?.radioGenero && {
          tipoGenero:
            storage.radioGenero === "AS"
              ? "ATENDE"
              : storage.radioGenero === "SR"
                ? "SEM_RESTRICAO"
                : storage.radioGenero === "NA"
                  ? "NAO_ATENDE"
                  : "",
        }),

        generos: generos.length > 0 ? generos : [],

        ...(storage?.radioFaixaEtaria && {
          restricao:
            storage.radioFaixaEtaria === "TO"
              ? "TODOS"
              : storage.radioFaixaEtaria === "AT"
                ? "ATENDE"
                : storage.radioFaixaEtaria === "CR"
                  ? "COM_RESTRICAO"
                  : "",
        }),

        ...(idadeMin && {
          idadeMinima: Number(idadeMin),
        }),

        ...(idadeMax && {
          idadeMaxima: Number(idadeMax),
        }),
        restricaoDeficiencia:
          storage?.radioSaudeCriancaDeficiencia?.length > 0
            ? storage?.radioSaudeCriancaDeficiencia
            : [],

        restricaoSubstancias:
          storage?.radioSaudeSubstanciasPsicoativas?.length > 0
            ? storage?.radioSaudeSubstanciasPsicoativas
            : [],

        restricaoCuidados:
          storage?.radioSaudeCriancaCuidados?.length > 0
            ? storage?.radioSaudeCriancaCuidados
            : [],
      },

      regularidade: {
        registroCMDCA: storage?.registroCMDCA ? storage?.registroCMDCA : [],
        registroValidoCMDCA: storage?.registroValidoCMDCA
          ? storage?.registroValidoCMDCA
          : [],
        inscricaoCMDCA: storage?.inscricaoCMDCA ? storage?.inscricaoCMDCA : [],
        inscricaoValidaCMDCA: storage?.inscricaoValidaCMDCA
          ? storage?.inscricaoValidaCMDCA
          : [],
        inscricaoCMAS: storage?.inscricaoCMAS ? storage?.inscricaoCMAS : [],
        inscricaoValidaCMAS: storage?.inscricaoValidaCMAS
          ? storage?.inscricaoValidaCMAS
          : [],
      },

      planejamento: {
        possuiPlanoTrabalho: storage?.possuiPlano ? storage?.possuiPlano : [],
        possuiProjetoPoliticoPedagogico: storage?.possuiProjeto
          ? storage?.possuiProjeto
          : [],
        possuiRelatorioAnual: storage?.possuiRelatorio
          ? storage?.possuiRelatorio
          : [],
        possuiRegimentoInterno: storage?.possuiRegimento
          ? storage?.possuiRegimento
          : [],
      },

      possuiAcessoMCA: storage?.possuiAcessoMCA ? storage?.possuiAcessoMCA : [],
      possuiVoluntariado: storage?.possuiVoluntariado
        ? storage?.possuiVoluntariado
        : [],

      apadrinhamento: {
        mantemProgramaApadrinhamento: storage?.mantemPrograma
          ? storage?.mantemPrograma
          : [],
        inscritoCMDCA: storage?.encontraInscritoCMDCA
          ? storage?.encontraInscritoCMDCA
          : [],
      },
      ...((storage?.possuiVaga === "S" || storage?.possuiVaga === "N") && {
        vagasDisponiveis: storage?.possuiVaga === "S",
      }),
    };

    try {
      setLoadingExcel(true);
      await RelatorioService.getExecelListaRelatorioServicoAcolhimento(
        valuesToSend,
      );

      Swal.fire({
        title: "Em processamento",
        html: `<div style="text-align: center;">Este relatório está sendo processado em segundo plano. <br /> Para acompanhar, verifique a sua fila de processamento localizado no <br /> menu lateral do sistema.</div>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Ir para Fila de Processamento",
        cancelButtonText: "Fechar",
        width: "600px",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/fila-processamento");
        }
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message ? error?.response?.data?.message : "",
        icon: "error",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const [data, setData] = useState();
  const isDisabled = loadingExcel || !data?.content?.length;

  return roleKeycloack ? (
    <Flex
      flex={1}
      flexDir="column"
      px={["5px", "32px"]}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <Group
        mt={1}
        title={"Relatório de Serviço de Acolhimento"}
        opcoes={true}
        dividerFalse={true}
      >
        <>
          <Box mt={4}>
            <FiltersRelatorioServicoAcolhimento
              data={data}
              setData={setData}
              setLoading={setLoading}
              loading={loading}
              entidade="relatorio-servico-acolhimento"
              user={user}
              roleKeycloack={roleKeycloack}
              atualizarDadosTabela={atualizarDadosTabela}
              setAtualizarDadosTabela={setAtualizarDadosTabela}
              setMostrarTabela={setMostrarTabela}
              mostrarTabela={mostrarTabela}
            >
              <TabPanels>
                <TabPanel>
                  {
                    <>
                      {mostrarTabela && (
                        <>
                          {!loading && data ? (
                            <>
                              <Text
                                mt={4}
                                fontWeight={700}
                                fontSize="18px"
                                lineHeight="136%"
                                color={`#169499`}
                              >
                                Relatório Gerado:
                              </Text>

                              <Flex
                                mt={4}
                                alignItems="center"
                                gap={2}
                                flexWrap="wrap"
                                maxWidth="100%"
                              >
                                <Text color="#575553">
                                  {`Data da Geração: ${format(
                                    new Date(),
                                    "dd/MM/yyyy",
                                  )} ${format(new Date(), "HH")}h${format(
                                    new Date(),
                                    "mm",
                                  )}`}
                                </Text>
                              </Flex>

                              <Flex
                                mt={4}
                                alignItems="center"
                                justifyContent="end"
                                gap={4}
                              >
                                <PrintButtonRelatorioServico
                                  user={user}
                                  entidade={"relatorio-servico-acolhimento"}
                                  dados={usuarioLogado}
                                  roleKeycloack={roleKeycloack}
                                />

                                <Menu>
                                  {({ isOpen }) => (
                                    <>
                                      <MenuButton
                                        type="button"
                                        cursor={
                                          isDisabled ? "not-allowed" : "pointer"
                                        }
                                        pointerEvents={
                                          isDisabled ? "none" : "auto"
                                        }
                                      >
                                        <Flex alignItems="center" gap={2}>
                                          <Flex
                                            bg={
                                              isDisabled ? "#A9A9A9" : "#006400"
                                            }
                                            rounded="full"
                                            p={1}
                                          >
                                            <RiFileExcel2Line color="white" />
                                          </Flex>

                                          <Text
                                            as="b"
                                            color={
                                              isDisabled ? "#A9A9A9" : "#006400"
                                            }
                                            fontSize="md"
                                          >
                                            Exportar em Excel
                                          </Text>

                                          {!isDisabled && (
                                            <Icon
                                              as={ChevronDownIcon}
                                              color="#006400"
                                              boxSize={6}
                                              transition="transform 0.2s"
                                              transform={
                                                isOpen
                                                  ? "rotate(180deg)"
                                                  : "rotate(0deg)"
                                              }
                                            />
                                          )}
                                        </Flex>
                                      </MenuButton>

                                      <MenuList>
                                        <MenuItem
                                          cursor={"pointer"}
                                          pr={6}
                                          py={3}
                                          justifyContent="space-between"
                                          as="strong"
                                          onClick={() =>
                                            !isDisabled &&
                                            getExportarExecel("basico")
                                          }
                                        >
                                          Básico{" "}
                                          <FaDownload
                                            color="#006064"
                                            size={16}
                                          />
                                        </MenuItem>
                                        <MenuItem
                                          cursor={"pointer"}
                                          pr={6}
                                          py={3}
                                          justifyContent="space-between"
                                          as="strong"
                                          onClick={() =>
                                            !isDisabled &&
                                            getExportarExecel("completo")
                                          }
                                        >
                                          Completo{" "}
                                          <FaDownload
                                            color="#006064"
                                            size={16}
                                          />
                                        </MenuItem>
                                      </MenuList>
                                    </>
                                  )}
                                </Menu>
                                {(storage?.tipoPeriodo === "D" ||
                                  storage?.dataInicio ||
                                  storage?.dataFim) && (
                                  <> {renderizarTooltip()} </>
                                )}
                              </Flex>

                              <TableRelatorioPendencia
                                data={data.content}
                                columns={columns}
                                isOpenNovoAcolhimento={isOpenNovoAcolhimento}
                                onOpenNovoAcolhimento={onOpenNovoAcolhimento}
                                onCloseNovoAcolhimento={onCloseNovoAcolhimento}
                                entidade="relatorio-servico-acolhimento"
                                atualizarDadosTabela={atualizarDadosTabela}
                                setAtualizarDadosTabela={
                                  setAtualizarDadosTabela
                                }
                                roleKeycloack={roleKeycloack}
                                user={user}
                                setData={setData}
                                idPJ={idPJ}
                              />
                            </>
                          ) : (
                            <Box mt={4}>
                              <LoadingSpinner />
                            </Box>
                          )}
                        </>
                      )}
                    </>
                  }
                </TabPanel>

                <TabPanel px={0}>
                  <Flex
                    borderRadius="12px"
                    boxShadow="0px 24px 40px 0px #00000014"
                    border="1px solid #00000014"
                    px={25}
                    py={10}
                  >
                    <Text
                      borderBottom="3px solid #169499"
                      as="b"
                      pb={2}
                      fontSize={"18px"}
                      display="flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                    >
                      <RiPushpinLine size={20} />
                      Status:
                      <Text fontWeight={"normal"}>
                        {(storage?.statusRelatorio || [])
                          ?.map(
                            (item) =>
                              ({
                                A: "Ativo",
                                S: "Suspenso",
                                D: "Desativado",
                              })[item],
                          )
                          .join(", ")}
                      </Text>
                    </Text>
                  </Flex>

                  <Flex
                    direction="column"
                    borderRadius="12px"
                    boxShadow="0px 24px 40px 0px #00000014"
                    border="1px solid #00000014"
                    mt={4}
                    px={25}
                    py={10}
                  >
                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Localização do Serviço de Acolhimento
                    </Text>

                    <SimpleGrid columns={4} spacing={3} w="100%" mt={10}>
                      {/* HEADER */}
                      <Text fontWeight="bold" color="#169499">
                        Estado
                      </Text>
                      <Text fontWeight="bold" color="#169499">
                        Município
                      </Text>
                      <Text fontWeight="bold" color="#169499">
                        Bairro
                      </Text>
                      <Text fontWeight="bold" color="#169499">
                        Nome do Serviço de Acolhimento
                      </Text>

                      {/* LINHA ÚNICA */}
                      <Text>
                        {storage?.idEstado?.[0]
                          ?.map((e) => e.nome)
                          .join(", ") || "Todos"}
                      </Text>

                      <Text>
                        {storage?.idMunicipio?.[0]?.[0]?.descricao === "Todos"
                          ? "Todos"
                          : storage?.idMunicipio?.[0]
                              ?.map((m) => m.descricao)
                              .join(", ") || "Todos"}
                      </Text>

                      <Text>
                        {storage?.idBairro?.[0]?.[0]?.descricao === "Todos"
                          ? "Todos"
                          : storage?.idBairro?.[0]
                              ?.map((b) => b.descricao)
                              .join(", ") || "Todos"}
                      </Text>

                      <Text>
                        {storage?.idsServicosAcolhimento?.[0]
                          ?.map((e) => e.nomeFantasia)
                          .join(", ") || "Todos"}
                      </Text>
                    </SimpleGrid>

                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Orgãos
                    </Text>
                    {!!storage?.idMunicipioOrgao &&
                      storage?.idMunicipioOrgao?.length > 0 && (
                        <>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                            mt={6}
                          >
                            Município
                          </Text>
                          <List styleType="disc" p={5}>
                            {storage?.idMunicipioOrgao[0]?.map((item) => (
                              <ListItem key={item.id}>
                                {item.descricao}
                              </ListItem>
                            ))}
                          </List>
                        </>
                      )}

                    {!!storage?.idPromotoriaOrgaos &&
                      storage?.idPromotoriaOrgaos?.length > 0 && (
                        <>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                            mt={6}
                          >
                            Promotoria de Justiça
                          </Text>
                          <List styleType="disc" p={5}>
                            {storage?.idPromotoriaOrgaos[0]?.map((item) => (
                              <ListItem key={item.id}>
                                {item.descricao}
                              </ListItem>
                            ))}
                          </List>
                        </>
                      )}

                    {!!storage?.idVaraOrgaos &&
                      storage?.idVaraOrgaos?.length > 0 && (
                        <>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                            mt={6}
                          >
                            Vara da Infância
                          </Text>
                          <List styleType="disc" p={5}>
                            {storage?.idVaraOrgaos[0]?.map((item) => (
                              <ListItem key={item.id}>
                                {item.descricao}
                              </ListItem>
                            ))}
                          </List>
                        </>
                      )}
                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Caracterização do Serviço de Acolhimento
                    </Text>
                    {((!!storage?.naturezaServico &&
                      storage?.naturezaServico?.length > 0) ||
                      (!!storage?.regime && storage?.regime?.length > 0) ||
                      (!!storage?.modalidade &&
                        storage?.modalidade?.length > 0)) && (
                      <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                        {/* HEADER */}
                        {!!storage?.naturezaServico &&
                          storage?.naturezaServico?.length > 0 && (
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Natureza do Serviço
                            </Text>
                          )}
                        {!!storage?.regime && storage?.regime?.length > 0 && (
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Regime
                          </Text>
                        )}
                        {!!storage?.modalidade &&
                          storage?.modalidade?.length > 0 && (
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Modalidade
                            </Text>
                          )}

                        <Box>
                          {storage?.naturezaServico?.[0]?.map((item) => (
                            <Text
                              key={item.id}
                              borderBottom="1px solid #00000014"
                              p={1}
                            >
                              {item.descricao}
                            </Text>
                          ))}
                        </Box>

                        <Box>
                          {storage?.regime?.[0]?.map((item) => (
                            <Text
                              key={item.id}
                              borderBottom="1px solid #00000014"
                              p={1}
                            >
                              {item.descricao}
                            </Text>
                          ))}
                        </Box>

                        <Box>
                          {storage?.modalidade?.[0]?.map((item) => (
                            <Text
                              key={item.id}
                              borderBottom="1px solid #00000014"
                              p={1}
                            >
                              {item.descricao}
                            </Text>
                          ))}
                        </Box>
                      </SimpleGrid>
                    )}

                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Perfil de Atendimento
                    </Text>

                    {((!!storage?.idGenero && storage?.idGenero?.length > 0) ||
                      !!storage?.radioGenero) && (
                      <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                        {/* HEADER */}
                        <>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Gênero
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          />
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          />
                        </>

                        {!!storage?.radioGenero && (
                          <Text p={1}>
                            {storage?.radioGenero === "SR"
                              ? "Sem Restrição"
                              : storage?.radioGenero === "AS"
                                ? "Atende Somente"
                                : storage?.radioGenero === "NA"
                                  ? "Não Atende"
                                  : ""}
                          </Text>
                        )}
                        {!!storage?.idGenero &&
                          storage?.idGenero?.length > 0 && (
                            <Text p={1}>
                              Gênero:{" "}
                              {storage?.idGenero?.[0]
                                ?.map((item) => item.genero)
                                .join(", ")}
                            </Text>
                          )}
                      </SimpleGrid>
                    )}

                    {/* HEADER */}
                    {(!!storage?.radioFaixaEtaria ||
                      !!storage?.idadeMinima ||
                      !!storage?.idadeMaxima ||
                      !!storage?.idadeInicial ||
                      !!storage?.idadeFinal) && (
                      <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                        <>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Faixa Etária
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          />
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          />
                        </>

                        {!!storage?.radioFaixaEtaria && (
                          <Text p={1}>
                            {storage?.radioFaixaEtaria === "TO"
                              ? "Todos"
                              : storage?.radioFaixaEtaria === "AT"
                                ? "Atende"
                                : storage?.radioFaixaEtaria === "CR"
                                  ? "Com Restrição de Faixa Etária"
                                  : ""}
                          </Text>
                        )}

                        {storage?.radioFaixaEtaria === "AT" && (
                          <>
                            {" "}
                            {!!storage?.idadeInicial &&
                              !!storage?.idadeFinal && (
                                <Text p={1}>
                                  De {storage?.idadeInicial} até{" "}
                                  {storage?.idadeFinal} anos
                                </Text>
                              )}
                          </>
                        )}

                        {storage?.radioFaixaEtaria === "CR" && (
                          <>
                            {" "}
                            {!!storage?.idadeMinima && (
                              <Text p={1}>
                                Idade Mínima aceita pelo Serviço:{" "}
                                {storage?.idadeMinima}
                              </Text>
                            )}
                            {!!storage?.idadeMaxima && (
                              <Text p={1}>
                                Idade Máxima Aceita pelo Serviço:{" "}
                                {storage?.idadeMaxima}
                              </Text>
                            )}
                          </>
                        )}
                      </SimpleGrid>
                    )}

                    {((storage?.radioSaudeCriancaDeficiencia?.length ?? 0) >
                      0 ||
                      (storage?.radioSaudeSubstanciasPsicoativas?.length ?? 0) >
                        0 ||
                      (storage?.radioSaudeCriancaCuidados?.length ?? 0) >
                        0) && (
                      <SimpleGrid columns={3} spacingY={3} w="100%" mt={10}>
                        {/* HEADER */}
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Saúde
                        </Text>
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        />
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        />

                        {(storage?.radioSaudeCriancaDeficiencia?.length ?? 0) >
                          0 && (
                          <Text p={1}>
                            Restrição de Criança/Adolescente com Deficiência:{" "}
                            {renderSN(storage.radioSaudeCriancaDeficiencia)}
                          </Text>
                        )}

                        {(storage?.radioSaudeSubstanciasPsicoativas?.length ??
                          0) > 0 && (
                          <Text p={1}>
                            Restrição de Criança/Adolescente que faz uso de
                            substâncias psicoativas:{" "}
                            {renderSN(storage.radioSaudeSubstanciasPsicoativas)}
                          </Text>
                        )}

                        {(storage?.radioSaudeCriancaCuidados?.length ?? 0) >
                          0 && (
                          <Text p={1}>
                            Faz Restrição de Criança/Adolescente que Demanda
                            Cuidados de Saúde:{" "}
                            {renderSN(storage.radioSaudeCriancaCuidados)}
                          </Text>
                        )}
                      </SimpleGrid>
                    )}

                    {roleKeycloack?.includes(
                      dashboardFunc.abasGestorDemais,
                    ) && (
                      <>
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Regularidade
                        </Text>

                        {((storage?.registroCMDCA?.length ?? 0) > 0 ||
                          (storage?.registroValidoCMDCA?.length ?? 0) > 0 ||
                          (storage?.inscricaoCMDCA?.length ?? 0) > 0 ||
                          (storage?.inscricaoValidaCMDCA?.length ?? 0) > 0 ||
                          (storage?.inscricaoCMAS?.length ?? 0) > 0 ||
                          (storage?.inscricaoValidaCMAS?.length ?? 0) > 0) && (
                          <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                            {((storage?.registroCMDCA?.length ?? 0) > 0 ||
                              (storage?.registroValidoCMDCA?.length ?? 0) >
                                0) && (
                              <Box>
                                {(storage?.registroCMDCA?.length ?? 0) > 0 && (
                                  <Text p={1}>
                                    Há Registro no CMDCA:
                                    {renderSN(storage?.registroCMDCA)}
                                  </Text>
                                )}

                                {(storage?.registroValidoCMDCA?.length ?? 0) >
                                  0 && (
                                  <Text p={1}>
                                    Há Registro Válido no CMDCA:
                                    {renderSN(storage?.registroValidoCMDCA)}
                                  </Text>
                                )}
                              </Box>
                            )}

                            {((storage?.inscricaoCMDCA?.length ?? 0) > 0 ||
                              (storage?.inscricaoValidaCMDCA?.length ?? 0) >
                                0) && (
                              <Box>
                                {(storage?.inscricaoCMDCA?.length ?? 0) > 0 && (
                                  <Text p={1}>
                                    Há Inscrição no CMDCA:
                                    {renderSN(storage?.inscricaoCMDCA)}
                                  </Text>
                                )}

                                {(storage?.inscricaoValidaCMDCA?.length ?? 0) >
                                  0 && (
                                  <Text p={1}>
                                    Há Inscrição Válida no CMDCA:
                                    {renderSN(storage?.inscricaoValidaCMDCA)}
                                  </Text>
                                )}
                              </Box>
                            )}

                            {((storage?.inscricaoCMAS?.length ?? 0) > 0 ||
                              (storage?.inscricaoValidaCMAS?.length ?? 0) >
                                0) && (
                              <Box>
                                {(storage?.inscricaoCMAS?.length ?? 0) > 0 && (
                                  <Text p={1}>
                                    Há Inscrição no CMAS:
                                    {renderSN(storage?.inscricaoCMAS)}
                                  </Text>
                                )}

                                {(storage?.inscricaoValidaCMAS?.length ?? 0) >
                                  0 && (
                                  <Text p={1}>
                                    HHá Inscrição Válida no CMAS:
                                    {renderSN(storage?.inscricaoValidaCMAS)}
                                  </Text>
                                )}
                              </Box>
                            )}
                          </SimpleGrid>
                        )}

                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Planejamento
                        </Text>

                        {((storage?.possuiPlano?.length ?? 0) > 0 ||
                          (storage?.possuiRegimento?.length ?? 0) > 0 ||
                          (storage?.possuiProjeto?.length ?? 0) > 0 ||
                          (storage?.possuiRelatorio?.length ?? 0) > 0) && (
                          <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                            {((storage?.possuiPlano?.length ?? 0) > 0 ||
                              (storage?.possuiRegimento?.length ?? 0) > 0) && (
                              <Box>
                                {(storage?.possuiPlano?.length ?? 0) > 0 && (
                                  <Text p={1}>
                                    Possui Plano de Trabalho:
                                    {renderSN(storage?.possuiPlano)}
                                  </Text>
                                )}

                                {(storage?.possuiRegimento?.length ?? 0) >
                                  0 && (
                                  <Text p={1}>
                                    Possui Regimento Interno:
                                    {renderSN(storage?.possuiRegimento)}
                                  </Text>
                                )}
                              </Box>
                            )}

                            {(storage?.possuiProjeto?.length ?? 0) > 0 && (
                              <Box>
                                {(storage?.possuiProjeto?.length ?? 0) > 0 && (
                                  <Text p={1}>
                                    Possui Projeto Político-Pedagógico:
                                    {renderSN(storage?.possuiProjeto)}
                                  </Text>
                                )}
                              </Box>
                            )}

                            {(storage?.possuiRelatorio?.length ?? 0) > 0 && (
                              <Box>
                                {(storage?.possuiRelatorio?.length ?? 0) >
                                  0 && (
                                  <Text p={1}>
                                    Possui Relatório Anual:
                                    {renderSN(storage?.possuiRelatorio)}
                                  </Text>
                                )}
                              </Box>
                            )}
                          </SimpleGrid>
                        )}

                        {!roleKeycloack?.includes(
                          dashboardFunc.abasDefensoriaOcultar,
                        ) && (
                          <>
                            <Text
                              borderBottom="3px solid #169499"
                              pb={2}
                              as="b"
                              fontSize={"18px"}
                              display="inline-flex"
                              alignItems="center"
                              gap={2}
                              mr={2}
                              mt={10}
                              w="fit-content"
                            >
                              <RiPushpinLine size={20} />
                              Equipe de Referência
                            </Text>

                            {(storage?.possuiAcessoMCA?.length ?? 0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacing={3}
                                w="100%"
                                mt={10}
                              >
                                {(storage?.possuiAcessoMCA?.length ?? 0) >
                                  0 && (
                                  <Box>
                                    {(storage?.possuiAcessoMCA?.length ?? 0) >
                                      0 && (
                                      <Text p={1}>
                                        Possui acesso ao MCA:
                                        {renderSN(storage?.possuiAcessoMCA)}
                                      </Text>
                                    )}
                                  </Box>
                                )}
                              </SimpleGrid>
                            )}

                            <Text
                              borderBottom="3px solid #169499"
                              pb={2}
                              as="b"
                              fontSize={"18px"}
                              display="inline-flex"
                              alignItems="center"
                              gap={2}
                              mr={2}
                              mt={10}
                              w="fit-content"
                            >
                              <RiPushpinLine size={20} />
                              Voluntariado
                            </Text>

                            {(storage?.possuiVoluntariado?.length ?? 0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacing={3}
                                w="100%"
                                mt={10}
                              >
                                {(storage?.possuiVoluntariado?.length ?? 0) >
                                  0 && (
                                  <Box>
                                    {(storage?.possuiVoluntariado?.length ??
                                      0) > 0 && (
                                      <Text p={1}>
                                        O Serviço de Acolhimento possui
                                        voluntariado:
                                        {renderSN(storage?.possuiVoluntariado)}
                                      </Text>
                                    )}
                                  </Box>
                                )}
                              </SimpleGrid>
                            )}
                          </>
                        )}

                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Programa de Apadrinhamento
                        </Text>

                        {(storage?.mantemPrograma?.length ?? 0) > 0 && (
                          <SimpleGrid columns={2} spacing={3} w="100%" mt={10}>
                            {(storage?.mantemPrograma?.length ?? 0) > 0 && (
                              <Box>
                                {(storage?.mantemPrograma?.length ?? 0) > 0 && (
                                  <Text p={1}>
                                    O Serviço de Acolhimento mantém Programa de
                                    Apadrinhamento:
                                    {renderSN(storage?.mantemPrograma)}
                                  </Text>
                                )}
                              </Box>
                            )}

                            {(storage?.encontraInscritoCMDCA?.length ?? 0) >
                              0 && (
                              <Box>
                                {(storage?.encontraInscritoCMDCA?.length ?? 0) >
                                  0 && (
                                  <Text p={1}>
                                    Em caso Positivo, esse Programa se encontra
                                    Inscrito no CMDCA:
                                    {renderSN(storage?.encontraInscritoCMDCA)}
                                  </Text>
                                )}
                              </Box>
                            )}
                          </SimpleGrid>
                        )}
                      </>
                    )}

                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Vagas Disponíveis
                    </Text>
                    {(storage?.possuiVaga?.length ?? 0) > 0 && (
                      <Text mt={6}>
                        Possui Vagas Disponíveis:{" "}
                        {renderSN(storage?.possuiVaga)}
                      </Text>
                    )}
                  </Flex>
                </TabPanel>
              </TabPanels>
            </FiltersRelatorioServicoAcolhimento>
          </Box>
        </>
      </Group>
    </Flex>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
